var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstBigCarousel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art-track-fill"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M1.5 5h14v14h-14zM17 5h2v14h-2zM20.5 5h2v14h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727272",
    d: "M4.5 15l2-2.5 1.24316 1.5537L9.5 11.5 12.25 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstBigCarousel);
export default __webpack_public_path__ + "static/media/firstBig_carousel.84e3570cd5ced1fdfd043be883b0a932.svg";
export { ForwardRef as ReactComponent };